import {PATTERNS} from '@/const';

export function validateEmail(value, LG, lang) {
  if (value === null) {
    return null;
  }
  if (PATTERNS.EMAIL.test(value)) {
    return null;
  }
  if (value) {
    return LG(lang.EmailError);
  }
  return LG(lang.NoEmailError);
}

export function validatePassword(value, LG, lang) {
  if (value === null) {
    return null;
  }
  if (PATTERNS.PASSWORD.test(value)) {
    return null;
  }
  if (value) {
    return LG(lang.PasswordError);
  }
  return LG(lang.NoPasswordError);
}
